export type BomPageView = 'loader' | 'bom';

/**
 * Decide whether a BOM request that has left the error paths is still loading.
 * A finished SM Ascender result can have zero parts when every array fails
 * the clamp check. That is a completed BOM, not a request that is still loading.
 */
export function bomPageView(input: {
  isLoading: boolean;
  isReady: boolean;
  isRailsFetching: boolean;
  shouldLoadRails: boolean;
  railsCount: number;
}): BomPageView {
  if (input.isLoading) {
    return 'loader';
  }
  if (input.isRailsFetching && input.shouldLoadRails) {
    return 'loader';
  }
  if (input.isReady) {
    if (!input.shouldLoadRails || input.railsCount > 0) {
      return 'bom';
    }
    return 'loader';
  }
  return 'loader';
}
